import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuroraBackground from '../components/AuroraBackground/AuroraBackground';
import AuroraNavbar from '../components/AuroraNavbar/AuroraNavbar';
import Footer from '../components/Footer';
import MetaHead from '../components/MetaHead';
import '../styles/pg-legal.css';

export default function MentionsLegales() {
  const { t, i18n } = useTranslation('legal');
  const isFrench = i18n.language === 'fr';

  return (
    <>
      <MetaHead page="legal_mentions" />
      <AuroraBackground dim />
      <AuroraNavbar />

      <main className="pg-legal">
        <h1 className="pg-legal-h1">{t('mentions.title')}</h1>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('mentions.editor_title')}</h2>
          <div className="pg-legal-dt">{t('mentions.editor_company_label')}</div>
          <div className="pg-legal-dd">{t('mentions.editor_company_value')}</div>
          <div className="pg-legal-dt">{t('mentions.editor_siren_label')}</div>
          <div className="pg-legal-dd">{t('mentions.editor_siren_value')}</div>
          <div className="pg-legal-dt">{t('mentions.editor_address_label')}</div>
          <div className="pg-legal-dd">{t('mentions.editor_address_value')}</div>
          <div className="pg-legal-dt">{t('mentions.editor_director_label')}</div>
          <div className="pg-legal-dd">{t('mentions.editor_director_value')}</div>
          <div className="pg-legal-dt">{t('mentions.editor_contact_label')}</div>
          <div className="pg-legal-dd">
            <a href="mailto:contact@getrevyo.com" className="pg-legal-link">contact@getrevyo.com</a>
          </div>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('mentions.hosting_title')}</h2>
          <div className="pg-legal-dt">{t('mentions.hosting_frontend_label')}</div>
          <div className="pg-legal-dd">
            {t('mentions.hosting_frontend_value')}
            <br />
            <a href="https://vercel.com" target="_blank" rel="noreferrer" className="pg-legal-link">vercel.com</a>
          </div>
          <div className="pg-legal-dt">{t('mentions.hosting_backend_label')}</div>
          <div className="pg-legal-dd">
            {t('mentions.hosting_backend_value')}
            <br />
            <a href="https://railway.app" target="_blank" rel="noreferrer" className="pg-legal-link">railway.app</a>
          </div>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('mentions.ip_title')}</h2>
          <p>{t('mentions.ip_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('mentions.data_title')}</h2>
          <p>
            {t('mentions.data_body_part1')}{' '}
            <Link to="/politique-de-confidentialite" className="pg-legal-link">{t('mentions.data_privacy_link')}</Link>
            {t('mentions.data_body_part2')}{' '}
            <a href="mailto:contact@getrevyo.com" className="pg-legal-link">contact@getrevyo.com</a>.
          </p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('mentions.law_title')}</h2>
          <p>{t('mentions.law_body')}</p>
        </div>

        {!isFrench && (
          <div className="pg-legal-disclaimer">{t('common.disclaimer_translation')}</div>
        )}
      </main>

      <Footer />
    </>
  );
}
